enum RedactDialogFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents",
	INTENTS = "intents",
	BORDER = "border",
	FILL = "fill",
	PAGE = "page",
	COLLISION = "collision",
	ANNOTATIONS = "annotations",
	IMAGES = "images",
	PATHES = "pathes",
	TEXTS = "texts",
	APPLY = "apply"
}

export default RedactDialogFields;